/**
 * Simple Maps - Write a simple map with a marker and overlay
 * http://wielink.nu
 *
 * Copyright 2013, Hermen van den Hoorn - http://www.vandenhoorn.net - http://www.wielink.nu
 *
 *	version: 1.0 initialize google maps with marker and simple overlay
 */

var GoogleMapsLoader = {
 	map : null,
	googleInitialized : false,
	geocoder : null,
	lat : null,
	lng : null,
	zoom: 12,
	markerIcon : '',

	init : function() {
		if(jQuery('div#gmap').length > 0) {
			jQuery('div#gmap').css({minHeight: '500px'});
			var mapData = jQuery('div#gmap').data() || {};
			if( mapData.zoom != undefined) {
				this.zoom = mapData.zoom;
			}
			if (mapData.lng && mapData.lat) {
				this.lat = mapData.lat;
				this.lng = mapData.lng
				this.initMap();
			}  else {
				address = jQuery('div#gmap').attr('data-address');
				this.geoCode(address, jQuery.proxy(this.initMap, this));
			}
		}
	},
	setMarkerIcon	: function(markerIcon) {
		this.markerIcon = markerIcon;
	},
	geoCode : function( address, callBackFunction ) {
		this.geocoder = new google.maps.Geocoder();
		this.geocoder.geocode( { address: address, language : 'nl'}, jQuery.proxy(this.geoCodeResults, this, callBackFunction));
	},
	geoCodeResults : function( callBackFunction, results, status ) {
		if (status == google.maps.GeocoderStatus.OK && results.length) {
			if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
				this.lat = results[0].geometry.location.lat();
				this.lng = results[0].geometry.location.lng();
				if (callBackFunction) {
					callBackFunction.call(this, 'lat', 'lon');
				}
			}
		}
	},
	initMap : function( arg1, arg2 ) {
		var myLatlng = new google.maps.LatLng(this.lat, this.lng);

		var mapOptions = {
          center: myLatlng,
          zoom: this.zoom*1,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        console.log(mapOptions);
        var infowindow = false;
        if (jQuery('div#gmap div.overlay').length >= 1) {
			infowindow = new google.maps.InfoWindow({
		    	content: jQuery('div#gmap').find('div.overlay').html()
			});
		}
        var map = new google.maps.Map(
			document.getElementById("gmap"),
            mapOptions
		);
		if (this.markerIcon != "") {
			var marker = new google.maps.Marker({
				position: myLatlng,
				map: map,
				icon : this.markerIcon
			});
		} else {
			var marker = new google.maps.Marker({
				position: myLatlng,
				map: map
			});
		}
		if ( infowindow ) {
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open(map,marker);
			});
		}
	}
};

export default GoogleMapsLoader;
